import React, { Component } from "react";
import { Layout, Breadcrumb, Button, PageHeader } from "antd";
import { RightOutlined } from "@ant-design/icons";
import CareUnitForm from "./CareUnitForm.js";
import CareUnitTable from "./CareUnitTable.js";

import { getOne as getCareUnit } from "../../api/CareUnit.js";

const { Content } = Layout;

/**
 *
 */
class CareUnits extends Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props);

    this.state = {
      showCareUnitForm: false,
      careUnitToEdit: null,
    };

    this.careUnitTable = React.createRef();

    this.onCreatedHandler = this.onCreatedHandler.bind(this);
    this.onCareUnitEditHandler = this.onCareUnitEditHandler.bind(this);
    this.addCareUnit = this.addCareUnit.bind(this);
  }

  /**
   *
   */
  onCreatedHandler = () => {
    this.careUnitTable.current.fetch({
      current: 1,
      pageSize: 10,
    });

    this.setState({
      showCareUnitForm: false,
    });
  };

  /**
   *
   */
  addCareUnit = () => {
    this.setState({
      showCareUnitForm: true,
    });
  };

  onCareUnitEditHandler = async (careUnitId) => {
    getCareUnit(careUnitId)
      .then((data) => {
        this.setState({
          showCareUnitForm: true,
          careUnitToEdit: data,
        });
      });
  };

  render() {
    return (
      <Content
        style={{
          margin: "24px 16px",
          padding: 24,
          minHeight: 280,
        }}
      >
        <Breadcrumb
          style={{ padding: 24 }}
          separator={<RightOutlined style={{ fontSize: "75%" }} />}
        >
          <Breadcrumb.Item>
            <a href="/home">Accueil</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Paramétrage</Breadcrumb.Item>
          <Breadcrumb.Item>Unités</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          ghost={false}
          title={'Unités'}
          extra={[
            <Button
              key="add"
              type="primary"
              size="large"
              onClick={this.addCareUnit}
            >
              Nouvelle unité
            </Button>,
          ]}
        />
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <CareUnitTable
            ref={this.careUnitTable}
            onEdit={this.onCareUnitEditHandler}
          />
          <CareUnitForm
            onCreated={this.onCreatedHandler}
            onClose={() => {
              this.setState({ showCareUnitForm: false, careUnitToEdit: null });
            }}
            visible={this.state.showCareUnitForm}
            careUnit={this.state.careUnitToEdit}
          />
        </div>
      </Content>
    );
  }
}

export default CareUnits;
